// extracted by css-extract-rspack-plugin
export default {"isLeft":"_d77a47a9"};